var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('applications-applicants-store',{attrs:{"store-on-created":true,"params":{
        application: _vm.$route.params.application,
        applicant: _vm.$route.query.applicant,
        tenant: _vm.$route.query.tenant
    }},on:{"success":_vm.onSuccess},scopedSlots:_vm._u([{key:"default",fn:function(ref){
    var error = ref.error;
    var store = ref.store;
return [_c('div',{staticClass:"py-6"},[_c('base-loading',{attrs:{"retry":store,"error":error}}),_vm._v(" "),(error && _vm.$error.is(error, { exclude: [403] }))?_c('error-modal',{attrs:{"error":error}}):_vm._e()],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }